module.exports = __webpack_public_path__ + "img/sn-logo.092e6b1a.png";